

document.addEventListener('DOMContentLoaded', function() {

  /**
   * Search brand selection
   */
  function searchDefaultBrandSelection() {
    const $searchBrandSelect = document.querySelector('[data-live-search-filter]');
    const $options = $searchBrandSelect.querySelectorAll('option');
    const { vendorLogo, currentVendor, vendors } = SDG.Data;
    const sessionVendor = sessionStorage.getItem('selectedBrand');
    const $siteLogo = document.querySelector('.site-logo');

    // Set selected brand to session storage
    if (currentVendor && vendors.includes(currentVendor)) {
      sessionStorage.setItem('selectedBrand', currentVendor);
    } else if (sessionVendor) {
      changeSelectValue(sessionVendor);
    }

    // Add event listener to select to keep brand selection in session storage
    $searchBrandSelect.addEventListener('change', function() {
      const selectedBrand = this.value.replace('vendor:', '');
      sessionStorage.setItem('selectedBrand', selectedBrand);
    });

    /**
     * Force change select value based on the current vendor
     * @param vendor String
     */
    function changeSelectValue(vendor) {
      if ($options) {
        $options.forEach(option => {
          const optionFiltered = option.value.replace('vendor:', '');
          if (optionFiltered === vendor) {
            option.selected = true;
          }
        });
        // Trigger dispatch event to force update select value
        $searchBrandSelect.dispatchEvent(new Event('change'));
      }

      // Updating logo link and image based on the selected brand
      if ($siteLogo) {
        const logoHref = $siteLogo.getAttribute('href');
        const vendorHandle = vendor.replace(' ', '-').toLowerCase();
        if (vendorHandle === 'athleta') {
          $siteLogo.setAttribute('href', `${logoHref}`);
        } else {
          $siteLogo.innerHTML = vendorLogo[vendor];
          $siteLogo.setAttribute('href', `${logoHref}${vendorHandle}`);
        }
      }
    }
  }

  /**
   * Move footer locale
   */
  function moveFooterLocale() {
    // Check for locale selector and move it to the footer content
    var checkElementExists = setInterval(function() {
      var $localeSelectorContainer = document.querySelector('.locale-selectors__container');

      if ($localeSelectorContainer) {
        clearInterval(checkElementExists);
        $('.locale-selectors__container').first().parent().appendTo('.js-site-footer-bottom');
      }
    }, 200);

    // Clear timeout after 10 seconds if the locale selector doesn't show up
    setTimeout(function() {
      if (checkElementExists) {
        clearInterval(checkElementExists);
      }
    }, 10000);
  }

  moveFooterLocale();

  searchDefaultBrandSelection();
});
